import React from 'react';
import styled from 'styled-components';
import { breakpoint } from '../../styling/mixins/breakpoints';
import Product from '../../Types/Product';
import ProductCardLandscape from '../ProductCards/ProductCardLandscape';

interface ProductPageVariantListProps {
  variants: Product[];
}

const StyledProductPageVariantList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.8rem;
  margin-top: 1.6rem;
  ${breakpoint('medium')} {
    margin-top: 2.4rem;
  }
`;

const ProductPageVariantList = ({ variants }: ProductPageVariantListProps) => {
  return (
    <StyledProductPageVariantList>
      {variants.map((p) => (
        <ProductCardLandscape
          product={p}
          isVariantListing={true}
          key={'ProductPageVariantList' + p.id}
        />
      ))}
    </StyledProductPageVariantList>
  );
};

export default ProductPageVariantList;
